// extracted by mini-css-extract-plugin
module.exports = {"popper":"SplitButton_popper__3nLyn","buttonArrow":"SplitButton_buttonArrow__3E0Il"};